import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getData } from './api';
import type { HomepageTrendingSectionDataErrorCode } from './types';

export const {
	Context: HomepageTrendingSectionDataContext,
	Provider: HomepageTrendingSectionDataContextProvider,
	useContext: useHomepageTrendingSectionData,
	useAsyncData: useHomepageTrendingSectionDataFromApi,
	prefetchAsyncData: prefetchHomepageTrendingSectionDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'HomepageTrendingSectionDataContext',
	dataProperty: 'trendingSectionData',
	getData,
	hookDeps: ({ countryCode, locale }) => [countryCode, locale],
	getUniqueId: ({ countryCode, locale }) => `${countryCode}:${locale}`,
	errorHandler: pageDataErrorHandler<HomepageTrendingSectionDataErrorCode>(),
});
